import { useEffect, useState } from "react";
import { PortalPage, Spinner, ErrorNote } from "@/components/PortalPage";
import { Accordion, Paragraphs, useSingleOpen } from "@/components/ContentParts";
import { api } from "@/lib/api";

export default function Handbook() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [openId, toggle] = useSingleOpen();
  useEffect(() => { api("/handbook/sections").then(setData).catch((e) => setErr(e.message)); }, []);
  return (
    <PortalPage eyebrow={data?.version ? `VERSION ${data.version}` : "EMPLOYEE HANDBOOK"} title="Employee Handbook" testId="handbook-page">
      <ErrorNote>{err}</ErrorNote>
      {!data && !err && <Spinner />}
      {data?.sections?.map((s, i) => (
        <Accordion key={s.id} id={s.id} eyebrow={`SECTION ${i + 1}`} title={s.title} open={openId === s.id} onToggle={() => toggle(s.id)}>
          <Paragraphs text={s.body} />
        </Accordion>
      ))}
    </PortalPage>
  );
}
